import createIcon from '../../createIcon';

/**
 * @component @name Iron
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkMxOS4zNCA2IDE4IDcuMzQgMTggOVYxM0MxOCAxMy41NSAxNy41NSAxNCAxNyAxNFYxMEMxNyA4LjM0IDE1LjY2IDcgMTQgN0gxMEM4LjM0IDcgNyA4LjM0IDcgMTBIOUM5IDkuNDUgOS40NSA5IDEwIDlIMTRDMTQuNTUgOSAxNSA5LjQ1IDE1IDEwVjExSDZDMy43OSAxMSAyIDEyLjc5IDIgMTVWMThIMTdWMTZDMTguNjYgMTYgMjAgMTQuNjYgMjAgMTNWOUMyMCA4LjQ1IDIwLjQ1IDggMjEgOEgyMlY2SDIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Iron = createIcon('Iron', [
  [
    'path',
    {
      d: 'M21 6C19.34 6 18 7.34 18 9V13C18 13.55 17.55 14 17 14V10C17 8.34 15.66 7 14 7H10C8.34 7 7 8.34 7 10H9C9 9.45 9.45 9 10 9H14C14.55 9 15 9.45 15 10V11H6C3.79 11 2 12.79 2 15V18H17V16C18.66 16 20 14.66 20 13V9C20 8.45 20.45 8 21 8H22V6H21Z',
      key: '116kt5',
    },
  ],
]);

export default Iron;
